import eventListener from '@synergycms_core/middlewares/eventListener';


export default eventListener("loyalty", []);
